import { render } from "./CompanySearchView.vue?vue&type=template&id=74642e54"
import script from "./CompanySearchView.vue?vue&type=script&lang=js"
export * from "./CompanySearchView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__